import { Paint } from "../interface";
import bagnata from "../images/bagnata LO.jpg";
import incrocioDiMignoli from "../images/incrocio di mignoli 2022.jpg";
import ventoNeiCapelli from "../images/vento nei capelli LO.jpg";
import voltoNellAcqua from "../images/volto_acqua 2022.jpg";
import sguardoAlloSpecchio from "../images/sguardo allo specchio per Lorenzo Pacini.jpg";
import amore from "../images/l'amore 2018.jpg";
import occhiDiLuna from "../images/occhi di luna.jpg";
import dolceSguardo from "../images/dolce sguardo.jpg";
import falconeBorsellino from "../images/disegno falcone borsellino 2022.webp";
import ofelia from "../images/Ofelia 2022.jpg";
import ariaDiLiberta from "../images/aria di libertà tratteggio grafite 24x33 2019.jpg";
import irene from "../images/Irene matita a pastello su legno 100x70 cm.jpg";
import laCivetta from "../images/la civetta 36x36 acquerello.jpg";
import salutoAlTramonto from "../images/ciao.webp";
import confusione from "../images/confusione LO.jpg";
import gigiProietti from "../images/gigi poietti.jpg";
import nudoAnni80 from "../images/nudo anni 80 grafite su carta 33x48 2o19.jpg";
import nudoTerraEMare from "../images/nudo terra e mare LO.jpg";
import gingerHeads from "../images/gingers heads 33x48 pastello su carta 2018.jpg";
import donnaCheSogna from "../images/donna che sogna grafite su carta 33x48 2018.jpg";
import laMiaLilith from "../images/La mia lilith 50x70 cm 2019.jpg";
import volareVia from "../images/Volare via 2020.jpg";
import rinascita from "../images/Rinascita 2020.jpg";
import danteELaDiavolessa from "../images/un anomalo dante e la Diavolessa.jpg";
import fellini8eMezzo from "../images/Fellini 8 e mezzo.jpg";
import guerraFraAcquaEFuoco from "../images/guerra fra acqua e fuoco 2019.jpg";
import assenzaDellEssenza from "../images/l'essenza dell'assenza 2020.jpg";
import reCheDovevaMorire from "../images/omaggio a Gianni Rodari  il re che doveva morire.jpg";
import autunno from "../images/l'autunno.jpg";
import n201920202021mas from "../images/n201920202021 mas.jpg";
import lol_3924 from "../images/LOL_3924.jpg";
import lol_3926 from "../images/LOL_3926.jpg";
import menzioneAlMerito from "../images/menzioneAlMerito2024.jpg";
import terraLontana from "../images/terra lontana per ponte vecchio 2024 bu.jpg";
import unaGiornataTranquilla from "../images/una giornata tranquilla.jpg";
import inMedioStatVirtus from "../images/in Medio stat virtus LOL.jpg"
import lunaTramontaSulMare from "../images/2025 La luna tramonta sul mare lo.jpg"
import amoreUniversale from "../images/Amore Universale.jpg"
import ilDoloreNegliOcchi from "../images/Il dolore negli occhi 2025.jpg"

export const paints: Paint[] = [
  {
    id: 1,
    src: bagnata,
    title: "Bagnata",
    description: "Grafite",
    paintSize: "48 x 33 cm",
    year: 2023,
    height: 550,
    width: 800,
    mobileHeight: 172,
    mobileWidth: 250,
  },
  {
    id: 2,
    src: incrocioDiMignoli,
    title: "Incrocio di Mignoli",
    description: "Matita a cera in carta gialla",
    paintSize: "70 x 50 cm",
    year: 2022,
    height: 571,
    width: 800,
    mobileHeight: 179,
    mobileWidth: 250,
  },
  {
    id: 3,
    src: ventoNeiCapelli,
    title: "Vento nei Capelli",
    description: "Grafite",
    paintSize: "48 x 35 cm",
    year: 2023,
    height: 583,
    width: 800,
    mobileHeight: 182,
    mobileWidth: 250,
  },
  {
    id: 4,
    src: voltoNellAcqua,
    title: "Volto nell'Acqua",
    description: "Matita a cera in carta gialla",
    paintSize: "70 x 50 cm",
    year: 2022,
    height: 571,
    width: 800,
    mobileHeight: 179,
    mobileWidth: 250,
  },
  {
    id: 5,
    src: sguardoAlloSpecchio,
    title: "Sguardo Allo Specchio",
    description: "Grafite",
    paintSize: "20 x 30 cm",
    year: 2021,
    height: 675,
    width: 450,
    mobileHeight: 375,
    mobileWidth: 250,
  },
  {
    id: 6,
    src: amore,
    title: "L'Amore",
    description: "Grafite",
    paintSize: "33 x 48 cm",
    year: 2020,
    height: 655,
    width: 450,
    mobileHeight: 364,
    mobileWidth: 250,
  },
  {
    id: 7,
    src: occhiDiLuna,
    title: "Occhi di Luna",
    description: "Matite a pastello e graffi di chiodo su mdf",
    paintSize: "70 x 100 cm",
    year: 2019,
    height: 643,
    width: 450,
    mobileHeight: 357,
    mobileWidth: 250,
  },
  {
    id: 8,
    src: dolceSguardo,
    title: "Dolce Sguardo",
    description: "Matita a pastello",
    paintSize: "33 x 48 cm",
    year: 2019,
    height: 655,
    width: 450,
    mobileHeight: 363,
    mobileWidth: 250,
  },
  {
    id: 9,
    src: falconeBorsellino,
    title: "Falcone e Borsellino",
    description: "Grafite e matite colorate su carta Modigliani ",
    paintSize: "100 x 70 cm",
    year: 2022,
    height: 560,
    width: 800,
    mobileHeight: 175,
    mobileWidth: 250,
  },
  {
    id: 9,
    src: ofelia,
    title: "Ofelia",
    description: "Matita a pastello e graffi di chiodo su mdf",
    paintSize: "70 x 100 cm",
    year: 2022,
    height: 643,
    width: 450,
    mobileHeight: 357,
    mobileWidth: 250,
  },
  {
    id: 11,
    src: ariaDiLiberta,
    title: "Aria di Libertà",
    description: "Grafite",
    paintSize: "25 x 33 cm",
    year: 2018,
    height: 594,
    width: 450,
    mobileHeight: 330,
    mobileWidth: 250,
  },
  {
    id: 12,
    src: irene,
    title: "Irene La Pace",
    description: "Matite a pastello su mdf",
    paintSize: "70 x 100 cm",
    year: 2019,
    height: 643,
    width: 450,
    mobileHeight: 357,
    mobileWidth: 250,
  },
  {
    id: 13,
    src: laCivetta,
    title: "La Luna e la Civetta",
    description: "Acquerello su carta",
    paintSize: "40 x 40 cm",
    year: 2020,
    height: 650,
    width: 650,
    mobileHeight: 250,
    mobileWidth: 250,
  },
  {
    id: 14,
    src: salutoAlTramonto,
    title: "Il saluto al tramonto",
    description: "Acrilico e matita a pastello",
    paintSize: "100 x 70 cm",
    year: 2024,
    height: 560,
    width: 800,
    mobileHeight: 175,
    mobileWidth: 250,
  },
  {
    id: 15,
    src: confusione,
    title: "Confusione",
    description: "Gessetto",
    paintSize: "50 x 70 cm",
    year: 2023,
    height: 630,
    width: 450,
    mobileHeight: 350,
    mobileWidth: 250,
  },
  {
    id: 16,
    src: gigiProietti,
    title: "Ritratto di Gigi Proietti",
    description: "Foto dal suo repertorio. Grafite",
    paintSize: "33 x 48 cm",
    year: 2021,
    height: 655,
    width: 450,
    mobileHeight: 364,
    mobileWidth: 250,
  },
  {
    id: 17,
    src: nudoAnni80,
    title: "Nudo di donna '80",
    description: "Tratto da una famosa foto degli anni 80. Grafite",
    paintSize: "33 x 48 cm",
    year: 2017,
    height: 655,
    width: 450,
    mobileHeight: 364,
    mobileWidth: 250,
  },
  {
    id: 18,
    src: nudoTerraEMare,
    title: "Nudo terra e mare",
    description: "Gessetto",
    paintSize: "70 x 80 cm",
    year: 2023,
    height: 514,
    width: 450,
    mobileHeight: 286,
    mobileWidth: 250,
  },
  {
    id: 19,
    src: gingerHeads,
    title: "Ginger Heads",
    description: "Matite a pastello",
    paintSize: "33 x 48 cm",
    year: 2017,
    height: 655,
    width: 450,
    mobileHeight: 364,
    mobileWidth: 250,
  },
  {
    id: 20,
    src: donnaCheSogna,
    title: "Donna che sogna",
    description: "Grafite",
    paintSize: "33 x 48 cm",
    year: 2017,
    height: 655,
    width: 450,
    mobileHeight: 364,
    mobileWidth: 250,
  },
  {
    id: 21,
    src: laMiaLilith,
    title: "La mia Lilith",
    description: "Acquerello e pastello su carta 300 gr",
    paintSize: "60 x 80 cm",
    year: 2021,
    height: 667,
    width: 500,
    mobileHeight: 333,
    mobileWidth: 250,
  },
  {
    id: 22,
    src: volareVia,
    title: "Volare Via",
    description: "Foto dal web rielaborata. Grafite e matite colorate",
    paintSize: "33 x 48 cm",
    year: 2020,
    height: 655,
    width: 450,
    mobileHeight: 364,
    mobileWidth: 250,
  },
  {
    id: 23,
    src: rinascita,
    title: "La Primavera",
    description: "Grafite e matite acquerellabili",
    paintSize: "33 x 48 cm",
    year: 2019,
    height: 655,
    width: 450,
    mobileHeight: 364,
    mobileWidth: 250,
  },
  {
    id: 24,
    src: danteELaDiavolessa,
    title: "Un anomalo Dante e la Diavolessa",
    description: "Dedicato a Dante Alighieri. Matite a cera",
    paintSize: "50 x 70 cm",
    year: 2021,
    height: 630,
    width: 450,
    mobileHeight: 350,
    mobileWidth: 250,
  },
  {
    id: 25,
    src: fellini8eMezzo,
    title: "Fellini in 8 e mezzo",
    description: "Composizione fatta con foto tratte dal film. Grafite",
    paintSize: "48 x 33 cm",
    year: 2020,
    height: 550,
    width: 800,
    mobileHeight: 172,
    mobileWidth: 250,
  },
  {
    id: 26,
    src: guerraFraAcquaEFuoco,
    title: "Guerra fra acqua e fuoco",
    description: "Foto rielaborata dal web. Matite a pastello",
    paintSize: "35 x 48 cm",
    year: 2019,
    height: 617,
    width: 450,
    mobileHeight: 342,
    mobileWidth: 250,
  },
  {
    id: 27,
    src: assenzaDellEssenza,
    title: "Assenza dell'Essenza",
    description: "Dedicato alla mia Venezia. Grafite e matite colorate",
    paintSize: "70 x 50 cm",
    year: 2020,
    height: 571,
    width: 800,
    mobileHeight: 179,
    mobileWidth: 250,
  },
  {
    id: 28,
    src: reCheDovevaMorire,
    title: "il Re che doveva morire",
    description: "Tratto da una favola di Gianni Rodari. Matite a pastello",
    paintSize: "40 x 50 cm",
    year: 2019,
    height: 625,
    width: 500,
    mobileHeight: 313,
    mobileWidth: 250,
  },
  {
    id: 29,
    src: autunno,
    title: "L'autunno",
    description: "Matite a pastello su carta",
    paintSize: "50 x 70 cm",
    year: 2020,
    height: 630,
    width: 450,
    mobileHeight: 350,
    mobileWidth: 250,
  },
  {
    id: 30,
    src: n201920202021mas,
    title: "#2019#2020#2021",
    description: "Matite a cera su carta colorata",
    paintSize: "50 x 70 cm",
    year: 2022,
    height: 630,
    width: 450,
    mobileHeight: 350,
    mobileWidth: 250,
  },
  {
    id: 31,
    src: lol_3924,
    title: "New Ginger Heads",
    description: "Matite a cera su carta colorata",
    paintSize: "50 x 70 cm",
    year: 2022,
    height: 630,
    width: 450,
    mobileHeight: 350,
    mobileWidth: 250,
  },
  {
    id: 32,
    src: lol_3926,
    title: "New Ginger Heads",
    description: "Matite a cera su carta colorata",
    paintSize: "50 x 70 cm",
    year: 2022,
    height: 630,
    width: 450,
    mobileHeight: 350,
    mobileWidth: 250,
  },
  {
    id: 33,
    src: menzioneAlMerito,
    title: "New Ginger Heads",
    description: "Matite a cera su carta colorata",
    paintSize: "50 x 70 cm",
    year: 2024,
    height: 630,
    width: 450,
    mobileHeight: 350,
    mobileWidth: 250,
  },
  {
    id: 34,
    src: terraLontana,
    title: "Terra Lontana",
    description:
      "IX concorso Nazionale Ponte Vecchio 2024. Pastello e acrilico su carta",
    paintSize: "70 x 50 cm",
    year: 2022,
    height: 571,
    width: 800,
    mobileHeight: 179,
    mobileWidth: 250,
  },
  {
    id: 35,
    src: unaGiornataTranquilla,
    title: "Una Giornata Tranquilla",
    description:
      "210° anniversario della formazione dell'arma dei Carabinieri. Pastello su carta",
    paintSize: "100 x 70 cm",
    year: 2024,
    height: 560,
    width: 800,
    mobileHeight: 175,
    mobileWidth: 250,
  },
  {
    id: 36,
    src: inMedioStatVirtus,
    title: "In Medio Stat Virtus",
    description:
      "tecnica mista cera e acrilico",
    paintSize: "100 x 70 cm",
    year: 2025,
    height: 560,
    width: 800,
    mobileHeight: 175,
    mobileWidth: 250,
  },
  {
    id: 37,
    src: lunaTramontaSulMare,
    title: "La Luna tramonta sul mare",
    description:
      "tecnica mista pastello e acrilico",
    paintSize: "100 x 70 cm",
    year: 2025,
    height: 560,
    width: 800,
    mobileHeight: 175,
    mobileWidth: 250,
  },
  {
    id: 38,
    src: amoreUniversale,
    title: "Amore Universale",
    description:
      "Matite",
    paintSize: "40 x 30 cm",
    year: 2025,
    height: 488,
    width: 650,
    mobileHeight: 188,
    mobileWidth: 250,
  },
  {
    id: 39,
    src: ilDoloreNegliOcchi,
    title: "Il Dolore negli Occhi",
    description:
      "tecnica mista su cartone",
    paintSize: "100 x 70 cm",
    year: 2025,
    height: 560,
    width: 800,
    mobileHeight: 175,
    mobileWidth: 250,
  },
];
